import React, { useRef, useEffect } from 'react';
import { useUserActions } from 'src/store/users/actions';
import { useDispatch, useSelector } from 'react-redux';
import { DeleteDataModel } from 'src/models/usersModel';
import { RootState } from 'src/store/reducers/state';
interface IProps {
    deleteData: DeleteDataModel | undefined;
}
const DeleteMembersModal: React.FC<IProps> = ({ deleteData }) => {
    const dispatch = useDispatch();
    const userActions = useUserActions(dispatch);
    const ref = useRef<HTMLButtonElement>(null);
    const handleDeleteClick = () => {
        if (deleteData) {
            userActions.deleteMemberRequest(deleteData.id);
        }
    };
    const { isMemberDeleted } = useSelector((state: RootState) => {
        return {
            isMemberDeleted: state.users.isMemberDeleted
        };
    });
    useEffect(() => {
        if (isMemberDeleted) {
            if (ref.current) {
                ref.current.click();
            }
        }
    }, [isMemberDeleted]);
    return (
        <div>
            <div
                className="modal fade"
                id="DeleteMembersModal"
                aria-labelledby="DeleteMembersModalLabel"
                aria-hidden="true">
                <div className="modal-dialog relative w-auto pointer-events-none max-w-xl">
                    <div className="modal-content">
                        <div
                            className="relative modal-header flex flex-shrink-0 items-center justify-end p-4 rounded-t-md"
                            style={{ borderBottom: 'none' }}>
                            <button
                                ref={ref}
                                type="button"
                                className="dismiss-btn"
                                data-bs-dismiss="modal"
                                aria-label="Close"></button>
                        </div>
                        <div className="modal-body relative pt-0 pb-4 px-10">
                            <form>
                                <div className="mb-4">
                                    <h4 className="text-xl font-semibold mb-1" style={{ color: '#111827' }}>
                                        Delete {deleteData && deleteData.name}?
                                    </h4>
                                    <p className="mb-3 text-xl font-semibold mb-1" style={{ color: '#111827', fontSize: '0.95rem' }}>
                                        Email: {deleteData?.email}
                                    </p>
                                    <p className="mb-2" style={{ color: '#374151' }}>
                                        This will permanently delete <strong style={{ color: '#111827' }}>{deleteData && deleteData.name}</strong> and
                                        all associated data.
                                    </p>
                                    <p className="mb-0" style={{ color: '#111827' }}>
                                        <strong>This action cannot be undone.</strong>
                                    </p>
                                </div>

                                <div
                                    className="text-left mx-auto p-3 rounded"
                                    style={{
                                        backgroundColor: '#FEF2F2',
                                        border: '1px solid #FCA5A5'
                                    }}>
                                    <p className="mb-2 font-bold" style={{ color: '#B91C1C' }}>
                                        The following will be permanently removed:
                                    </p>
                                    <ul className="mb-0 pl-4" style={{ color: '#B91C1C' }}>
                                        <li>Course access</li>
                                        <li>Purchase history</li>
                                        <li>Progress and analytics</li>
                                        <li>Any associated certificates and CE records</li>
                                    </ul>
                                </div>
                            </form>
                        </div>

                        <div className="modal-footer flex flex-shrink-0 flex-wrap items-center justify-center p-4 pb-6 pt-4 rounded-b-md">
                            <button
                                onClick={handleDeleteClick}
                                type="button"
                                className="btn-danger w-auto inline-block mt-0 mx-0 px-4 py-2 bg-red-600 border-red-600 text-white hover:bg-red-200 mr-2">
                                Delete Member
                            </button>
                            <button
                                type="button"
                                className="mx-0 px-6 btn-primary discard-btn w-auto whitespace-nowrap mt-0"
                                data-bs-dismiss="modal">
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeleteMembersModal;
